import React, {
  useState,
  createContext,
  useMemo,
  useCallback,
} from 'react';
import PropTypes from 'prop-types';

export const STEPS = {
  AUTH: 0,
  FILL_DOCUMENTS: 1,
  LIVENESS: 2,
  FILL_FIELDS: 2,
  FINISH: 3,
};

export const CurrentStepContext = createContext();

export const CurrentStepContextProvider = ({ children }) => {
  const [currentStep, setCurrentStep] = useState(STEPS.AUTH);

  const setDocumentStep = useCallback(() => {
    setCurrentStep(STEPS.FILL_DOCUMENTS);
  }, []);

  const setFieldsStep = useCallback(() => {
    setCurrentStep(STEPS.FILL_FIELDS);
  }, []);

  const setFinishStep = useCallback(() => {
    setCurrentStep(STEPS.FINISH);
  }, []);

  const setLivenessStep = useCallback(() => {
    setCurrentStep(STEPS.LIVENESS);
  }, []);

  const value = useMemo(
    () => ({
      currentStep,
      setCurrentStep,
      setDocumentStep,
      setFieldsStep,
      setFinishStep,
      setLivenessStep,
    }),
    [
      currentStep,
      setCurrentStep,
      setDocumentStep,
      setFieldsStep,
      setFinishStep,
      setLivenessStep,
    ],
  );

  return (
    <CurrentStepContext.Provider value={value}>
      { children }
    </CurrentStepContext.Provider>
  );
};

CurrentStepContextProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
};
